export const InputModes = ['search', 'none', 'email', 'text', 'decimal', 'url', 'tel', 'numeric', undefined] as const;
export type InputModeType = (typeof InputModes)[number];
